import { Component, ErrorInfo, ReactNode } from 'react';
import { posthog } from '../services/posthog';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class PostHogErrorBoundary extends Component<Props, State> {
  public state: State = { hasError: false };
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // Capture with PostHog
    if (posthog) {
      posthog.captureException(error, {
        componentStack: errorInfo.componentStack,
        errorBoundary: true,
        severity: 'error'
      });
    }
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || (
        <div className="flex flex-col items-center justify-center min-h-screen p-4 text-center bg-brand-cream text-charcoal">
          <h2 className="text-2xl font-bold mb-4">Something went wrong</h2>
          <p className="mb-6">We've been notified and are looking into it.</p>
          <button 
            onClick={() => this.setState({ hasError: false })}
            className="px-6 py-2 bg-brand-red text-white rounded-full font-bold shadow-lg hover:bg-red-600 transition-colors"
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
